<div [ngClass]="toolTipClass" @tooltip>{{ text }}</div>
